module.exports = __webpack_public_path__ + "img/piggy-bank.5313dc99.webp";